import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Users,
  Building2,
  Thermometer,
  ArrowLeft,
  ShieldCheck,
  Grid3X3,
  UserCircle,
  CalendarCheck2,
  Megaphone,
  Brain,
  Flame,
  FileCode2,
  ShoppingBag,
  ClipboardList,
  Radio,
} from "lucide-react";

import ScadenzeAdmin from "./ScadenzeAdmin";
import UtentiRuoli from "./UtentiRuoli";
import AziendeFrighi from "./AziendeFrighi";
import DispositiviCryo from "./DispositiviCryo";
import AziendePiani from "./AziendePiani";
import PianiFunzioni from "./PianiFunzioni";
import ProfiloAzienda from "./ProfiloAzienda";
import LoginMarketingAdmin from "./LoginMarketingAdmin";
import AttrezzatureProposteAdmin from "./AttrezzatureProposteAdmin";
import NozioniNormaAIAdmin from "./NozioniNormaAIAdmin";
import FriggitriciAdmin from "./FriggitriciAdmin";
import ManualeHaccpTemplateAdmin from "./ManualeHaccpTemplateAdmin";
import AdminShop from "./AdminShop";
import HardwareOrdersAdmin from "./HardwareOrdersAdmin";

export default function Admin() {
  const [tab, setTab] = useState("utenti");
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/api/me.php", { credentials: "include" })
      .then((r) => r.json())
      .then((data) => {
        setMe(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const isSuper =
    me?.ruolo === "superadmin" ||
    (Array.isArray(me?.permessi) && me.permessi.includes("ALL"));

  const canEditProfile = me?.ruolo === "admin" || me?.ruolo === "superadmin";
  const canManageFriggitrici =
    me?.ruolo === "admin" || me?.ruolo === "superadmin";

  if (loading) {
    return <div className="p-4">Caricamento admin...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="bg-gradient-to-r from-slate-900 via-indigo-700 to-sky-500 text-white shadow-md">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-white/10 flex items-center justify-center">
              <ShieldCheck size={20} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-wide opacity-80">
                Area riservata
              </div>
              <h1 className="text-2xl font-bold leading-tight">
                Pannello di Controllo
              </h1>
              <p className="text-sm opacity-90">
                {isSuper
                  ? "Accesso completo (superadmin)"
                  : canEditProfile
                    ? "Accesso amministratore azienda"
                    : "Accesso in sola lettura"}
              </p>
            </div>
          </div>

          <div className="flex gap-2 items-center">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-semibold">{me?.nome || me?.email}</div>
              <div className="text-xs opacity-80">
                {me?.email} • {me?.ruolo}
              </div>
            </div>
            <button
              onClick={() => navigate("/")}
              className="rounded-lg bg-white/10 hover:bg-white/20 px-3 py-1.5 text-sm flex items-center gap-1"
            >
              <ArrowLeft size={14} /> Torna alla dashboard
            </button>
          </div>
        </div>
      </div>

      {/* TABS */}
      <div className="max-w-6xl mx-auto px-4 pt-4 flex gap-2 flex-wrap">
        <button
          onClick={() => setTab("utenti")}
          className={tab === "utenti" ? activeBtn : normalBtn}
        >
          <Users size={16} /> Utenti
        </button>

        <button
          onClick={() => setTab("piani")}
          className={tab === "piani" ? activeBtn : normalBtn}
        >
          <ShieldCheck size={16} /> Piani aziende
        </button>

        <button
          onClick={() => setTab("aziende")}
          className={tab === "aziende" ? activeBtn : normalBtn}
        >
          <Building2 size={16} /> Aziende & Frighi
        </button>

        <button
          onClick={() => setTab("cryo")}
          className={tab === "cryo" ? activeBtn : normalBtn}
        >
          <Thermometer size={16} /> Dispositivi / Cryo
        </button>

        {canManageFriggitrici && (
          <button
            onClick={() => setTab("friggitrici")}
            className={tab === "friggitrici" ? activeBtn : normalBtn}
          >
            <Flame size={16} /> Friggitrici
          </button>
        )}

        <button
          onClick={() => setTab("pianiFunzioni")}
          className={tab === "pianiFunzioni" ? activeBtn : normalBtn}
        >
          <Grid3X3 size={16} /> Funzioni / Piani
        </button>

        <button
          onClick={() => setTab("scadenze")}
          className={tab === "scadenze" ? activeBtn : normalBtn}
        >
          <CalendarCheck2 size={16} /> Attività & Scadenze
        </button>

        {isSuper && (
          <button
            onClick={() => setTab("attrezzatureProposte")}
            className={tab === "attrezzatureProposte" ? activeBtn : normalBtn}
          >
            <Thermometer size={16} /> Richieste attrezzature
          </button>
        )}

        {isSuper && (
          <button
            onClick={() => setTab("nozioniNormaAI")}
            className={tab === "nozioniNormaAI" ? activeBtn : normalBtn}
          >
            <Brain size={16} /> Nozioni Norma AI
          </button>
        )}

        {isSuper && (
          <button
            onClick={() => setTab("manualeTemplate")}
            className={tab === "manualeTemplate" ? activeBtn : normalBtn}
          >
            <FileCode2 size={16} /> Template Manuale HACCP
          </button>
        )}

        {isSuper && (
          <button
            onClick={() => setTab("shop")}
            className={tab === "shop" ? activeBtn : normalBtn}
          >
            <ShoppingBag size={16} /> Shop
          </button>
        )}

        {isSuper && (
          <button
            onClick={() => navigate("/admin/lorawan-devices")}
            className={normalBtn}
          >
            <Radio size={16} /> LoRaWAN
          </button>
        )}

        {isSuper && (
          <button
            onClick={() => setTab("hardwareOrders")}
            className={tab === "hardwareOrders" ? activeBtn : normalBtn}
          >
            <ClipboardList size={16} /> Ordini hardware
          </button>
        )}

        <button
          onClick={() => setTab("profilo")}
          className={tab === "profilo" ? activeBtn : normalBtn}
        >
          <UserCircle size={16} /> Profilo
        </button>

        {isSuper && (
          <button
            onClick={() => setTab("loginMarketing")}
            className={tab === "loginMarketing" ? activeBtn : normalBtn}
          >
            <Megaphone size={16} /> Login Marketing
          </button>
        )}
      </div>

      {/* CONTENUTO */}
      <div className="max-w-6xl mx-auto px-4 py-4">
        {tab === "utenti" && <UtentiRuoli isSuper={isSuper} />}
        {tab === "piani" && <AziendePiani isSuper={isSuper} />}
        {tab === "aziende" && <AziendeFrighi isSuper={isSuper} />}
        {tab === "cryo" && <DispositiviCryo isSuper={isSuper} />}

        {tab === "friggitrici" && canManageFriggitrici && (
          <FriggitriciAdmin me={me} isSuper={isSuper} />
        )}

        {tab === "pianiFunzioni" && <PianiFunzioni isSuper={isSuper} />}
        {tab === "scadenze" && <ScadenzeAdmin me={me} isSuper={isSuper} />}

        {tab === "attrezzatureProposte" && isSuper && <AttrezzatureProposteAdmin />}
        {tab === "nozioniNormaAI" && isSuper && <NozioniNormaAIAdmin />}

        {tab === "manualeTemplate" && isSuper && (
          <ManualeHaccpTemplateAdmin isSuper={isSuper} />
        )}

        {tab === "shop" && isSuper && <AdminShop />}

        {tab === "hardwareOrders" && isSuper && (
          <HardwareOrdersAdmin isSuper={isSuper} />
        )}

        {tab === "profilo" && (
          <ProfiloAzienda me={me} canEdit={canEditProfile} isSuper={isSuper} />
        )}

        {tab === "loginMarketing" && isSuper && (
          <LoginMarketingAdmin isSuper={isSuper} />
        )}
      </div>
    </div>
  );
}

/* STILI BOTTONI */
const activeBtn =
  "px-4 py-2 rounded-full bg-slate-900 text-white shadow-sm flex items-center gap-2";

const normalBtn =
  "px-4 py-2 rounded-full bg-white text-slate-700 hover:bg-slate-100 shadow-sm flex items-center gap-2";
